import { supabase } from '@/lib/supabase';

export interface SellerNotice {
  id: string;
  title: string;
  content: string;
  priority: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const sellerNoticesService = {
  // 모든 공지사항 가져오기
  async getAllNotices() {
    try {
      const { data, error } = await supabase
        .from('seller_notices')
        .select('*')
        .eq('is_active', true)
        .order('priority', { ascending: false })
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching seller notices:', error);
        return { success: false, error: error.message };
      }

      return { success: true, data: data as SellerNotice[] };
    } catch (error) {
      console.error('Unexpected error:', error);
      return { success: false, error: '공지사항을 불러오는 중 오류가 발생했습니다' };
    }
  },

  // 특정 공지사항 가져오기
  async getNoticeById(id: string) {
    try {
      const { data, error } = await supabase
        .from('seller_notices')
        .select('*')
        .eq('id', id)
        .single();

      if (error) {
        console.error('Error fetching seller notice:', error);
        return { success: false, error: error.message };
      }

      return { success: true, data: data as SellerNotice };
    } catch (error) {
      console.error('Unexpected error:', error);
      return { success: false, error: '공지사항을 불러오는 중 오류가 발생했습니다' };
    }
  },

  // 중요 공지사항만 가져오기 (priority >= 5)
  async getImportantNotices() {
    try {
      const { data, error } = await supabase
        .from('seller_notices')
        .select('*')
        .eq('is_active', true)
        .gte('priority', 5)
        .order('priority', { ascending: false })
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching important seller notices:', error);
        return { success: false, error: error.message };
      }

      return { success: true, data: data as SellerNotice[] };
    } catch (error) {
      console.error('Unexpected error:', error);
      return { success: false, error: '중요 공지사항을 불러오는 중 오류가 발생했습니다' };
    }
  }
};